// 弹窗关闭时的参数
export const DIALOG_CLOSED_TYPE = {
    CONFIRM: "CONFIRM",
    CANCEL: "CANCEL",
    CLOSE: "CLOSE",
    CALLBACK: "CALLBACK",
    NEXT: 'NEXT',
};

// 用户类型
export const USER_TYPE = {
    SUPPLERMANAGER: 1,
    TENATMANAGER: 2,
    MANAGER: 3, // 主体管理员
    PERCHASE: 4, // 用户 采购员
    SUPPLIER: 5  // 供应商
}

export function getOrderCompleteByValue(val) {
    var type = ORDER_COMPLETE.find(obj => obj.value === val)
    return type ? type.label : ''
}

export const ORDER_COMPLETE =
[
    {value: 'E', label: "未完成"},
    {value: 'X', label: "完成"}
]
//附件业务类型(暂时)
export const FILE_BIZ_TYPE = [
    {value: 1, label: "process-definition-xml"},
    {value: 2, label: "process-definition-jpg"},
    {value: 3, label: "email-template"},
    {value: 4, label: "apply-form-freeze"},
    // 供应商
    {value: 5, label: "supplier-basic-info"},
    {value: 6, label: "project-basic-info"},
    // 采购合同
    {value: 7, label: "contact-basic-info"},
    // 价格协议
    {value: 8, label: "price-agreement-basic-info"},
    //订单管理
    {value: 9, label: "order-basic-info"},
    //技术通知
    {value: 10, label: "tech-basic-info"},
    // 交货单管理
    {value: 11, label: "delivered-basic-info"},
    //任务管理
    {value: 12, label: "task-basic-info"},
    //报价管理
    {value: 13, label: "rfq-quotation-info"},
    // 供应商门户
    {value: 14, label: "supplier-portal-info"},
    // 量产订单
    {value: 15, label: "sop-order-info"},
    // 审批单管理
    {value: 16, label: "rfq-audit-info"},
    // 报价管理-供应商上传
    {value: 17, label: "rfq-quotation-supplier"},
    //供应商-通知公告上传
    {value: 18, label: "supplier-notice"},
    //结算管理-发票
    {value: 21, label: "settlement-invoice"},
]
// 车型信息
export const CAR_TYPE = [
    {value: 0, label: "微卡"},
    {value: 1, label: "小卡"},
    {value: 2, label: "中卡"},
    {value: 3, label: "皮卡"}
]

export function getCAR_TYPE(val) {
    var type = CAR_TYPE.find(obj => obj.value === val)
    return type ? type.label : val
}


// 询价状态
// 新建 0       草稿(点发出通知结束) => 待询价 (发出询价) =>  询价中 (结束状态: 截至时间结束 OR 全部报价 ) =>  询价截至(已开标)  =>  1.发起下一轮  =>
                                                                                                                            //2.提交审批  => 通过/驳回 : 已定点/已驳回(可发起下一轮)
// // 询价状态
// export const RFQ_STATUS1 = {
//     RFQSTART: 1,
//     RFQING: 2,
//     RFQEND: 3
// }

export const RFQ_STATUS = {
    /**
     * 草稿
     * 采购去添加供应商 并且选择[询价截至时间]
     * (点 通知询价 结束)
     * Buttons: 暂存,通知询价
     * Func: 添加供应商
    */
    BEGIN: '0',

    /**
     * 待询价
     * 该过程 采购需要观察每家供应商的[回复状态]
     * 此时能不能继续添加供应商? TODO
     * (点 发出询价 结束)
     * Buttons: 发出询价
     * Func:
     *
    */
    BEFORE_ASK: '1',

    /**
     * 询价中
     * 该过程 采购查看每个供应商的[报价状态], 此阶段需等待供应商报价, 不可以查看任何供应商的报价详情
     * (结束状态: [询价截至时间] OR 全部报价)
     * 是否到截止日期
     * Buttons: [查看报价](disable: 全部报价)  [延期报价](主动延长[询价截至时间])
     * Func:
     *
    */
    ASKING: '2',

    /**
     * 已开标
     * 查看供应商报价
     *     |比价? =>
     *             | => A.进行下一轮,回到2 继续添加筛选供应商 开完标以后可以改，不删除供应商，可以加
     *             | => B.比价决策出最优选,此时[创建审批单]
     *
     * (结束状态: [进行下一轮] OR [拟定审批单])
     * Buttons: [比价]  A[下一轮](过滤部分供应商 进行下一轮)   B[拟定审批单](确认零件采购方案,如同时选择多家供应商,校验供货比例达到100%)
     * Func:
     *
    */
    COMPARING: '3',

    /**
     * 待提交
     * 以[提交审批]结束
     * 可以编辑审批单,没问题点提交审批
     * Buttons: [暂存审批单] [提交审批]
     *
    */
    EDITING: '4',


    /**
     * 已提交
     * 查看详细 不可修改任何数据
     * Buttons: null
     *
    */
    SUBMITTED : '5',


    // 审批结束

    //审批通过 ()
    APPROVED: '6a',

    //驳回
    //button： [下一轮] => 2  [修改审批单] => 5
    REJECT: '6b',



    // 定厂结束
    DECIDED: '7',



    // 拟定价格协议
    PRICE_ARGUMENT: '8',
}

export const RFQ_STATUS_VALUE = [
    {value: '0', label: '草稿'},
    {value: '1', label: '待询价'},
    {value: '2', label: '询价中'},
    {value: '3', label: '已开标'},
    {value: '4', label: '待提交'},
    {value: '5', label: '已提交'},
    {value: '6a', label: '审批通过'},
    {value: '6b', label: '驳回'},
    {value: '7', label: '定厂结束'},
    {value: '8', label: '拟定价格协议'},
]


export const proceVisibleSet = new Set([
    RFQ_STATUS.COMPARING,
    RFQ_STATUS.EDITING,
    RFQ_STATUS.SUBMITTED,
    RFQ_STATUS.APPROVED,
    RFQ_STATUS.REJECT,
    RFQ_STATUS.DECIDED,
])
// 采购员：
// 询价状态
// 新建 0
// 询价中 1
// 询价截止 2 （提前截止）
// 已开标 3   （截止之后开标） 开标定时任务
//     发起下一轮，回到询价中状态
// 提交审批
// 已定点
// 已驳回 发起下一轮

// 供应商：
// 未处理
// 已参与
// 已拒绝 原因
// 已保存
// 已提交



export function getRFQ_STATUS_VALUE(val) {
    const rfqStatus = RFQ_STATUS_VALUE.find(obj => obj.value === val)
    return rfqStatus ? rfqStatus.label : ''
}

// 询价状态
export const QUOTATION_STATUS = {
    BEGIN: '1',
    JOINED: '2',
    REJECT: '3',
    COMMITED: '4',
    DECIDED: '5',
    CONFIRM: '6',
}

export const QUOTATION_STATUS_VALUE = [
    {value: '1', label: '未处理'},
    {value: '2', label: '已参与'},
    {value: '3', label: '已拒绝'},
    {value: '4', label: '已报价'},
    //{value: '5', label: '已选定'},
    //{value: '6', label: '已确认'},
]

export const AUDIT_STATUS=[
    {value: '提交审批单', label: '提交审批单'},
    {value: '采购科长审批', label: '采购科长审批'},
    {value: '采购部长审批', label: '采购部长审批'},
    {value: '流程结束', label: '流程结束'},
    {value: '已选定', label: '已选定'},
]

export function getQUOTATION_STATUS_VALUE(val) {
    var status = QUOTATION_STATUS_VALUE.find(obj => obj.value === val)
    return status? status.label : ''
}

// 供应商询价状态
// 等待/同意报价/弃权
export const SUPPLY_RFQ_STATUS = {
    WAITING: 0,
    GIVEUP: 1,
    AGREE: 2,
};

export const SUPPLY_RFQ_STATUS_VALUE = [
    {value: '0', label: "等待"},
    {value: '1', label: "同意报价"},
    {value: '2', label: "弃权"},
    {value: '3', label: "已报价"},
];

export function getSUPPLY_RFQ_STATUS_VALUE(val) {
    var status = SUPPLY_RFQ_STATUS_VALUE.find(obj => obj.value === val)
    return status? status.label : ''
}

export const SUPPLY_TYPE = {
    VOTED: 0,
    POTENTIAL: 1,
}

// 供应商类型
export const SUPPLY_TYPE_VALUE = [
    {value: '0', label: "潜在"},
    {value: '1', label: "合格"},
    {value: '2', label: "临时"},
];

export function getSUPPLY_TYPE_VALUE(val) {
    var type = SUPPLY_TYPE_VALUE.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 任务状态
export const TASK_STATUS = {
    WAITING: '0',
    DISTRIBUTED: '1',
    RECIEVED: '2',
    RFQING: '3',
    ORDERING: '4',
    REJECT: '5',
    RELEASED: '6'
}

export const TASK_STATUS_VALUE = [
    {value: '0', label: "待分配"},
    {value: '6', label: "待发布"},
    {value: '1', label: "已发布"},
    {value: '2', label: "已接受"},
    // {value: '3', label: "发布RFQ"},
    // {value: '4', label: "发布订单"},
    {value: '5', label: "已退回"},
    //{value: '7', label: "已完成分配"},
    {value: '8', label: "已废弃"},
    // 已完成分配  value: "7"
    // 已废弃  value: "8"

]

export function getTASK_STATUS_VALUE(val) {
    var type = TASK_STATUS_VALUE.find(obj => obj.value === val)
    return type ? type.label : ''
}
//项目状态
export const PROJECT_STATUS = [
    {value: '0', label: "新建"},
    {value: '1', label: "发布"}
]

//工序名称
export const PROCESS_NAME = [
    {value: '0', label: "第一工序"},
    {value: '1', label: "第二工序"}
]

//模具、夹具、检具成本工序名称
export const PROCESS = [{
        value: '0',
        label: "打磨"
    },
    {
        value: '1',
        label: "焊接"
    },
    {
        value: '2',
        label: "去毛刺"
    }
]

export function getprocessByValue(val) {
    var type = PROCESS.find(obj => obj.value === val)
    return type ? type.label : ''
    }

//技术通知状态
export const TECHNICAL_INFO_STATUS = [{
        value: '0',
        label: "新建"
    },
    {
        value: '1',
        label: "发布"
    },
    {
        value: '2',
        label: "已作废"
    }
]


export function getTechnicalStatusValue(val) {
    var type = TECHNICAL_INFO_STATUS.find(obj => obj.value === val)
    return type ? type.label : ''
}

//技术通知类型
export const TECHNICAL_NOTIFICATION_TYPE = [{
        value: '0',
        label: "定点通知"
    },
    {
        value: '1',
        label: "B点寻源"
    },
    /*{
        value: '2',
        label: "量产定价"
    },
    {
        value: '3',
        label: "ET/PT样件"
    },
    {
        value: '4',
        label: "B点开发/取消通知"
    },*/
]

export function getTechnicalValue(val) {
    var type = TECHNICAL_NOTIFICATION_TYPE.find(obj => obj.value === val)
    return type ? type.label : ''
}

//订单状态
export const ORDER_STATUS = [
    {
        value: '提交审批',
        label: "草稿"
    },
    {
        value: '研发审批',
        label: "已提交"
    },
    {
        value: '采购科长审批',
        label: "研发通过"
    },
    {
        value: '采购部长审批',
        label: "采购科长通过"
    },
    {
        value: '流程结束',
        label: "审批通过"
    },
    // {
    //     value: '4',
    //     label: "发布"
    // },
    // {
    //     value: '5',
    //     label: "供应商确认"
    // },
]

export function getSopOrderStatusByValue(val) {
    var type = ORDER_STATUS.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 量产订单状态
export const PRODUCTION_ORDER_STATUS = [
    // {value: '0', label: "新建"},
    {value: '0', label: "已发布"},
    {value: '1', label: "已确认"},
    {value: '2', label: "已关闭"},
]

export function getProductionOrderStatusByValue(val) {
    var type = PRODUCTION_ORDER_STATUS.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 订单类型
export const ORDER_TYPE = [
    {value: '0', label: "样件采购订单"},
    {value: '1', label: "量产采购订单"},
    {value: '2', label: "设变采购订单"},
    {value: '3', label: "定厂采购订单"},
]

export function getOrderTypeByValue(val) {
    var type = ORDER_TYPE.find(obj => obj.value === val)
    return type ? type.label : ''
}

//ASN状态
export const ASN_STATUS = [{
        value: '0',
        label: "草稿"
    },
    {
        value: '1',
        label: "审核中"
    },
    {
        value: '2',
        label: "审核通过"
    },
    {
        value: '3',
        label: "审核驳回"
    },
    {
        value: '4',
        label: "已关闭"
    },
    {
        value: '5',
        label: "已完成"
    }
]

// 同步状态
export const SYNC_STATUS = [{
    value: '0',
    label: "未同步"
},
{
    value: '2',
    label: "成功"
},
{
    value: '3',
    label: "失败"
}
]

export function getAsnStatusByValue(val) {
    var type = ASN_STATUS.find(obj => obj.value === val)
    return type ? type.label : ''
}

// SUPPLY_STATUS

//供货状态
export const SUPPLY_STATUS = [{
        value: 'S',
        label: "自制件"
    },
    {
        value: 'R',
        label: "委外加工"
    },
    {
        value: 'P',
        label: "外购件"
    }
]

export function getLabelByValue(dictArr,val) {
    var type = dictArr.find(obj => obj.value === val)
    return type ? type.label : ''
}

export const PURCHASE_MESSAGE_TYPE = [
    {value: '0', label: "入库结算"},
    {value: '2', label: "寄售"},
    {value: '3', label: "委外加工"}
]

export function getPURCHASE_MESSAGE_TYPE_VALUE(val) {
    var type =  PURCHASE_MESSAGE_TYPE.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 协议类型
export const AGREEMENT_TYPE = [
    {value: '0', label: "定厂价格协议"},
    {value: '1', label: "量产价格协议"}
]

export function getAGREEMENT_TYPE_VALUE(val) {
    var type = AGREEMENT_TYPE.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 协议状态
export const AGREEMENT_STATUS = [
    {value: '提交价格协议', label: "草稿"},
    {value: '供应商管理员审批', label: "已提交"},
    {value: '流程结束', label: "审批通过"},
    {value: '已同步', label: "已同步"},
]

export function getAGREEMENT_STATUS_VALUE(val) {
    var type = AGREEMENT_STATUS.find(obj => obj.value === val)
    return type ? type.label : ''
}
// 账期
export const PAY_PERIOD = [{
        value: 0,
        label: "先款后货",
        desc: "预付款"
    }, {
        value: 1,
        label: "货到付款",
        desc: "立即付款"
    }, {
        value: 2,
        label: "入仓结算,发票入账后30天",
        desc: "30 天账期"
    }, {
        value: 10,
        label: "入仓结算,发票入账后45天",
        desc: "45 天账期"
    }, {
        value: 3,
        label: "入仓结算,发票入账后60天",
        desc: "60 天账期"
    }, {
        value: 4,
        label: "下线结算,发票入账后30天",
        desc: "30 天账期"
    }, {
        value: 11,
        label: "下线结算,发票入账后45天",
        desc: "45 天账期"
    }, {
        value: 5,
        label: "下线结算,发票入账后60天",
        desc: "60 天账期"
    }, {
        value: 6,
        label: "出库(领用)结算,发票入账后30天",
        desc: "30 天账期"
    }, {
        value:12,
        label: "出库(领用)结算,发票入账后45天",
        desc: "45 天账期"
    }, {
        value: 7,
        label: "出库(领用)结算,发票入账后60天",
        desc: "60 天账期"
    }, {
        value: 8,
        label: "单车结算,发票入账后30天",
        desc: "30 天账期"
    }, {
        value: 13,
        label: "单车结算,发票入账后45天",
        desc: "45 天账期"
    }, {
        value: 9,
        label: "单车结算,发票入账后60天",
        desc: "60 天账期"
    }
]

export function getPAY_PERIOD_VALUE(val) {
    var type = PAY_PERIOD.find(obj => obj.value === val)
    return type ? type.label : val
}

// 合同类型
export const CONTRACT_TYPE_VALUE =  [{
    value: 0,
    label: "开发协议"
}, {
    value: 1,
    label: "价格协议"
}, {
    value: 2,
    label: "保密协议"
},{
    value: 3,
    label: "补充协议"
}, {
    value: 4,
    label: "电池回收协议"
}, {
    value: 5,
    label: "工装保管协议"
}, {
    value: 6,
    label: "样件采购合同"
}, {
    value: 7,
    label: "综合采购合同"
}, {
    value: 8,
    label: "采购通则"
}]

export function getCONTRACT_TYPE_VALUE(val) {
    var type =  CONTRACT_TYPE_VALUE.find(obj => obj.value === val)
    return type ? type.label : ''
}
//价格协议  结算方式
export const PAY_WAY_VALUE = [
    {value: 0, label: "承兑"},
    {value: 1, label: "电汇"},
    {value: 2, label: "承兑+电汇"}
]

export function  getPAY_WAY_VALUE(val) {
    var type = PAY_WAY_VALUE.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 辅助材料
export const ITEM_VALUE = [
    {value: '0', label: "电费"},
    {value: '1', label: "燃油费"},
    {value: '2', label: "煤气费"},
    {value: '3', label: "水"},
    {value: '4', label: "其他"}
]

export function getITEM_VALUE(val) {
    var type = ITEM_VALUE.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 采购合同 合同状态
export const CONTRACT_STATUS_VALUE = [
    {value: '0', label: "起草"},
    {value: '1', label: "签署完成"},
    {value: '2', label: "作废"},
]

export function getCONTRACT_STATUS_VALUE(val) {
    var type = CONTRACT_STATUS_VALUE.find(obj => obj.value === val)
    return type ? type.label : ''
}

export const SOP_ORDER_TYPE = [
    {value: 'NB', label: "标准采购订单-量产"},
    {value: 'ZNB', label: "标准采购订单-售后备件"},
    {value: 'ZNB1', label: "临时&样件采购订单"},
    {value: 'ZNB2', label: "非生产性物料采购订单"},
    {value: 'ZNB3', label: "整车采购订单"},
    {value: 'ZSTO', label: "跨公司调拨采购订单"},
    {value: 'ZTH', label: "采购退货采购订单"},
    {value: 'ZGC', label: "量产订单-钢材"},
    {value: 'MNB', label: "发动机标准采购订单"},
]

export const SOP_ORDER_TYPES = [
    {value: 'NB', label: "量产订单"},
    {value: 'ZNB1', label: "样件订单"},
    {value: 'ZNB', label: "售后订单"},
    {value: 'ZSTO', label: "跨公司调拨"},
    {value: 'ZGC', label: "量产订单-钢材"},
    {value: 'MNB', label: "发动机标准采购订单"},
]

export const SOP_ORDER_TYPES_LEFT = [
    {value: 'NB', label: "量产订单"},
    {value: 'ZNB', label: "售后订单"},
    {value: 'ZSTO', label: "跨公司调拨"},
    {value: 'ZGC', label: "量产订单-钢材"},
    {value: 'MNB', label: "发动机标准采购订单"},
]

export function getSopOrderTypeByValue(val) {
    var type = SOP_ORDER_TYPE.find(obj => obj.value === val)
    return type ? type.label : ''
}

export function getSopOrderTypesByValue(val) {
    var type = SOP_ORDER_TYPES.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 结算状态
export const ACCOUNT_TYPE_VALUE = [
    {value: '1', label: "寄售"},
    {value: '2', label: "入库结算"},
]

// 结算单状态
export const ACCOUNT_STATUS_VALUE = [
    {value: 'F', label: "已过帐"},
    {value: 'R', label: "已拒绝"},
    {value: 'L', label: "已删除"},
]

// 结算单状态
export const ACCOUNT_STATUS = [
    {value: 'A', label: "无状态"},
    {value: 'F', label: "已过帐"},
    {value: 'R', label: "已拒绝"},
    // {value: 'L', label: "已删除"},
]

// 单位
export const UNIT = [{
    value: 'PC',
    label: '件'
  }, {
    value: 'G',
    label: '克'
  }, {
    value: 'KG',
    label: '千克'
  }, {
    value: 'L',
    label: '升'
  }, {
    value: 'M',
    label: '米'
  },{
    value: 'ROL',
    label: '卷'
  },{
    value: 'BOT',
    label: '瓶'
  },{
    value: 'CM',
    label: '厘米'
  },{
    value: 'ML',
    label: '毫升'
  },{
    value: 'MM',
    label: '毫米'
  },{
    value: 'CAR',
    label: '辆'
  },]

export function getUnitValue(val) {
    var type = UNIT.find(obj => obj.value === val)
    return type ? type.label : ''
}

export const FACTORY = [{
    value: '1011',
    label: '北京汽车制造厂（青岛）有限公司-试制工厂'
  }, {
    value: '1012',
    label: '北京汽车制造厂（青岛）有限公司-销售工厂'
  }, {
    value: '1081',
    label: '北京汽车制造厂有限公司青岛分公司-生产工厂'
  }]

export function getFactoryValue(val) {
    var type = FACTORY.find(obj => obj.value === val)
    return type ? type.label : ''
}

export const AUDIT_TYPE_VALUE = {
    NEW_PRODUCT: '1',
    B_POINT: '2',
}

// 审批单类型
export const AUDIT_TYPE = [{
    value: '1',
    label: '新品'
  }, {
    value: '2',
    label: 'B点'
  }, {
       value: '3',
       label: '量产'
  }, {
       value: '4',
       abel: '设变'
  }]

  export function getAuditValue(val) {
      var type = AUDIT_TYPE.find(obj => obj.value === String(val))
      return type ? type.label : ''
  }

  //采购信息记录分类(0：入库结算 2：寄售 3：委外加工)
export const ESOKZ_TYPE = [{
    value: '0',
    label: "入库结算"
},
{
    value: '2',
    label: "寄售"
},
{
    value: '3',
    label: "委外加工"
},
]

export function getEsokzByValue(val) {
var type = ESOKZ_TYPE.find(obj => obj.value === val)
return type ? type.label : ''
}

// OPTION(C 新建/U修改)
export const CHOOSE_TYPE = [{
    value: 'c',
    label: "新建"
},
{
    value: 'u',
    label: "修改"
},
]

export function getChooseByValue(val) {
var type = CHOOSE_TYPE.find(obj => obj.value === val.toLowerCase())
return type ? type.label : ''
}

// 特别采购类型
export const SOBIN_TYPE = [{
    value: '',
    label: "标准"
},
{
    value: 'K',
    label: "寄售"
},
{
    value: 'L',
    label: "委外"
},
]

export function getSboinByValue(val) {
var type = SOBIN_TYPE.find(obj => obj.value === val)
return type ? type.label : ''
}

// 项目类别
export const PSTYP_TYPE = [{
    value: '',
    label: "标准"
},
{
    value: 'L',
    label: "委外"
},
{
    value: 'K',
    label: "寄售"
},
]

export function getPstypByValue(val) {
var type =  PSTYP_TYPE.find(obj => obj.value === val)
return type ? type.label : ''
}

// 是否暂估(暂估E/正式R)
export const KOSRT_TYPE = [{
    value: 'E',
    label: "暂估"
},
{
    value: 'R',
    label: "正式"
},
]

export function getKosrtByValue(val) {
var type = KOSRT_TYPE.find(obj => obj.value === val)
return type ? type.label : ''
}

// 工序名称
export const PROCESSNAME_VALUE = [{
    value: '0',
    label: "第一工序"
},
{
    value: 'R',
    label: "第二工序"
},
]
// 同步状态
export const SYNC_STATUS_PRICE = [{
    value: 0,
    label: "未同步"
},
{
    value: 1,
    label: "已同步"
},
{
    value: 2,
    label: "同步失败"
},
]
// 同步状态
export const SYNC_STATUS_QUOTA = [{
    value: 0,
    label: "未同步"
},
{
    value: 1,
    label: "已同步"
},
{
    value: 2,
    label: "同步失败"
},
{
    value: 3,
    label: "未同步"
},
]
export function getProcessNameByValue(val) {
var type = PROCESSNAME_VALUE.find(obj => obj.value === val)
return type ? type.label : ''
}

export const ASN_ORDER_TYPES = [
    {value: 'NB', label: "量产订单"},
    {value: 'ZNB1', label: "样件订单"},
    {value: 'ZSTO', label: "跨公司调拨"},
    {value: 'ZGC', label: "量产订单-钢材"},
    {value: 'MNB', label: "发动机标准采购订单"},
]

export const ASN_ORDER_TYPES_LEFT = [
    {value: 'NB', label: "量产订单"},
    {value: 'ZSTO', label: "跨公司调拨"},
    {value: 'ZGC', label: "量产订单-钢材"},
    {value: 'MNB', label: "发动机标准采购订单"},
]

export function getAsnOrderTypesByValue(val) {
    var type = ASN_ORDER_TYPES.find(obj => obj.value === val)
    return type ? type.label : ''
}

//定点申请状态
export const PLM_TECHNICAL_INFO_STATUS = [
    {
        value: '1',
        label: "发布"
    },
    {
        value: '2',
        label: "作废"
    },
]

export function getPLMTechnicalStatusValue(val) {
    var type = PLM_TECHNICAL_INFO_STATUS.find(obj => obj.value === val)
    return type ? type.label : ''
}

//定点申请接收状态
export const PLM_RECEIVE_STATUS = [
    {
        value: '0',
        label: "未接收"
    },
    {
        value: '1',
        label: "已接收"
    },
    {
        value: '2',
        label: "已反馈"
    },
]

export function getPLMReceiveStatusValue(val) {
    var type = PLM_RECEIVE_STATUS.find(obj => obj.value === val)
    return type ? type.label : ''
}

//定点申请类型
export const PLM_TECHNICAL_TYPE = [{
        value: '0',
        label: "定点通知"
    },
    {
        value: '1',
        label: "B点寻源"
    },
]

export function getPlmTechnicalTypeValue(val) {
    var type = PLM_TECHNICAL_TYPE.find(obj => obj.value === val)
    return type ? type.label : ''
}

export const RFQ_TYPE_VALUE = [
    {value: '0', label: '寻源通知'},
    {value: '1', label: 'B点寻源'},
    {value: '2', label: '量产定价'},
    {value: '3', label: '设变定价'}
]


export const SOURCE_TYPE_VALUE = [
    {value: '0', label: '招标'},
    {value: '1', label: '议标'}
]

//年度分类
export const YEAR_TYPE_VALUE = [
    {
        value: '0',
        label: "年度"
    },
    {
        value: '1',
        label: "上半年度"
    },
    {
        value: '2',
        label: "下半年度"
    },
]

//供应商分类
export const CLASS_TYPE_VALUE = [
    {
        value: 'A',
        label: "A"
    },
    {
        value: 'B',
        label: "B"
    },
    {
        value: 'C',
        label: "C"
    },
    {
        value: 'D',
        label: "D"
    },
]

export function getSYNC_STATUS_VALUE(val) {
    var type = SYNC_STATUS.find(obj => obj.value === val)
    return type ? type.label : ''
}

// 索赔状态
export const CLA_STATUS_VALUE = [
    {value: 0, label: "草稿"},
    {value: 1, label: "已发布"},
    {value: 2, label: "已确认"},
    {value: 3, label: "已关闭"}
]

